import ToggleButton from "@components/miscellany/toggle_button/toggle_button"
import store from '../../../../../store'
import('./button.css')

export default function Button(opts){
    BaseConstructor.call(this)
    let option_name = opts.option_name
    let elements = {}
    let context= this
    let toggleButton
    let current_state
    let chart_name = opts.chart_name
    this.getElement = _ =>{
        return elements.container
    }

    init()


    function init(){
        current_state = store.getChartNestedProp(chart_name, `statistics.list.${option_name}`)
        current_state = (current_state == 'true') ? true : false //é salvo em string, caso exista, convertendo para boolean

        elements.container = context.createElement('div')
        
        toggleButton = new ToggleButton({container:elements.container, custom_class: 'statistic-button', states:[{title: option_name, active: !current_state}, {title:option_name, classList: 'active', active:current_state}]})
        toggleButton.generate(0)

        toggleButton.on('click', () =>{
            current_state = !current_state

            store.setChartNestedProp(chart_name, `statistics.list.${option_name}`, current_state)
        })
    }
}

Button.prototype = Object.create(BaseConstructor.prototype)